import { custom } from "./actionsUtilities";
import { EMPTY_STRING, systemConstants, toastType } from "../../constants";
import { systemService } from "../../services";
import { customToast } from "../../shared/utility";

//-------activate spinner
const activateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.SPINNER_ACTIVATE));
  };
};

//-------Deactivate Spinner
const deactivateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.SPINNER_DEACTIVATE));
  };
};

const activateDraggableNotification = (message) => {
  return (dispatch) => {
    dispatch(custom(message, systemConstants.DRAGGABLE_NOTIFICATION_ACTIVATE));
  };
};

const deactivateDraggableNotification = (message) => {
  return (dispatch) => {
    dispatch(
      custom(message, systemConstants.DRAGGABLE_NOTIFICATION_DEACTIVATE)
    );
  };
};

//-------Page Redireaction
const pageRedireaction = (path) => {
  return (dispatch) => {
    dispatch(custom(path, systemConstants.TOGGLE_REDIRECT_PAGE));
  };
};

const dfStartOrchestrator = (data) => {
  return (dispatch) => {
    systemService
      .dfStartOrchestrator(data)
      .then(
        (response) => {},
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {});
  };
};

export const systemActions = {
  activateSpinner,
  deactivateSpinner,
  pageRedireaction,
  dfStartOrchestrator,
  activateDraggableNotification,
  deactivateDraggableNotification,
};
